export const TOTALEMAILS = 'TOTALEMAILS'
export const TOTALSPACEYEMAILS = 'TOTALSPACEYEMAILS'
export const REQUEST_PAYLOAD = 'REQUEST_PAYLOAD'
export const HASNEXT = 'HASNEXT'
export const RESPONSE_PAYLOAD = 'RESPONSE_PAYLOAD'
export const LASTPAGE = 'LASTPAGE'
export const PERPAGE = 'PERPAGE'
export const SETPAGE = 'SETPAGE'
export const STARTTIME = 'STARTTIME'
export const ENDTIME = 'ENDTIME'
export const ISFROMSEARCH = 'ISFROMSEARCH'
export const ISLOADING = 'ISLOADING'
export const UPDATEEMAILREAD = 'UPDATEEMAILREAD'
export const SORTING_FIELD = 'SORTING_FIELD';
export const SORTING_DIRECTION = 'SORTING_DIRECTION';

export const UPDATESTATUS = 'UPDATESTATUS'
export const UPDATEFLAG = 'UPDATEFLAG'
export const UPDATEPOINTS = 'UPDATEPOINTS'
export const UPDATEMARK = 'UPDATEMARK'
export const UPDATESCORE = 'UPDATESCORE'
export const TOTALSPACEY2019EMAILS = 'TOTALSPACEY2019EMAILS'
export const PAGING = 'PAGING'
export const CURRENT_PAGE_EMAIL_FROM_EMAIL_DATE = 'CURRENT_PAGE_EMAIL_FROM_EMAIL_DATE'
export const CURRENT_PAGE_EMAIL_FROM_MUID = 'CURRENT_PAGE_EMAIL_FROM_MUID'

export const REQUEST_PANELIST = 'REQUEST_PANELIST'

export const ID_TO_UPDATE = 'ID_TO_UPDATE'
export const UPDATE_ALL = 'UPDATE_ALL'
export const UPDATE_OBJECTS = 'UPDATE_OBJECTS'

export const REMOVE_UPDATE_OBJ = 'REMOVE_UPDATE_OBJ'

export const UPDATE_STATUS_BY_MUID = 'UPDATE_STATUS_BY_MUID'
export const UPDATE_FLAG_BY_MUID = 'UPDATE_FLAG_BY_MUID'
export const UPDATE_POINTS_BY_MUID = 'UPDATE_POINTS_BY_MUID'
export const UPDATE_MARK_BY_MUID = 'UPDATE_MARK_BY_MUID'

export const COMPETI_IDS = 'COMPETI_IDS'

export const PRODUCT_ID = 'PRODUCT_ID'

export const REMOVE_ALL_UPDATE_OBJECTS = 'REMOVE_ALL_UPDATE_OBJECTS'

export const REMOVE_ALL_UPDATE_OBJ = 'REMOVE_ALL_UPDATE_OBJ'
